<script type="text/javascript">
    import { http } from '../../http';
    import $ from 'jquery';
    import { getQueryParam } from '../../helpers';

    export default {
        props: {
            signupError: {
                required: false,
                default: '',
            },
            practizeShell: {
                required: false,
                type: Boolean,
                default: false,
            },
            extensibleOnboarding: {
                required: false,
                type: Boolean,
                default: false,
            },
        },

        data: () => ({
            email: '',
            loading: false,
            name: '',
            country: '',
            countries: [],
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Copenhagen',
            submitLoading: false,
            signupPageUrl: '/signup',
            discount: getQueryParam('discount') || null,
            practizeShellQuery: getQueryParam('practize_shell') === '1',
        }),

        mounted() {
            http.get('/signup/countries', {})
                .then(({data}) => {
                    this.countries = data;
                }).catch(() => {});

            this.bindInputListeners();

            this.$root.$on('countryUpdated', country => {
                this.$forceUpdate();
            });
        },

        updated() {
            this.bindInputListeners();
        },

        methods: {
            bindInputListeners() {
                $('input').off('focus');
                $('input').off('blur');

                $('input').on('focus', function () {
                    $('p.create-cta').addClass('hidden-xs');
                });

                $('input').on('blur', function () {
                    $('p.create-cta').removeClass('hidden-xs');
                });
            },

            signup() {
                this.submitLoading = true;
            }
        }
    }
</script>

<template id="login-form">
    <div>
        <div class="preloader" id="preloader" v-if="loading"></div>

        <div class="logo-container" v-if="!practizeShell"></div>

        <div :class="practizeShell ? 'practize-login-form' : 'login-form-wrapper form-wrapper'" id="loginFormWrapper" v-if="!loading">
            <div class="message-container" v-if="!extensibleOnboarding">
                <div class="message error-message" v-if="signupError">
                    <p>
                        <svg version="1.1" id="errorIcon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 47 47">
                            <g>
                                <path d="M22.8,46c-12.6-0.2-22.1-10.1-22-22.8C1,10.6,11.4,0.4,24,0.7C36.6,1,46.3,11.3,46.2,24.1C46,36.8,36,46.2,22.8,46z
                                     M23.5,40.8c10.1,0,17.4-7.2,17.4-17.2c0-10-7.4-17.6-17.2-17.7C13.7,5.8,6,13.5,6.1,23.6C6.2,33.7,13.4,40.8,23.5,40.8z"/>
                            </g>
                            <line class="st0" x1="23" y1="11" x2="23" y2="26"/>
                            <circle cx="23" cy="33" r="3"/>
                        </svg>
                        {{ signupError }}
                    </p>
                </div>
            </div>

            <form id="signup" :action="`/signup?back_url=${signupPageUrl}`" method="post" class="mainForm" :class="{ 'auth-signup-step-card': extensibleOnboarding }" @submit="signup">
                <template v-if="practizeShell && extensibleOnboarding">
                    <div class="auth-signup-step-header">
                        <div class="auth-signup-progress-row three" aria-hidden="true">
                            <span class="auth-signup-progress-dot active"></span>
                            <span class="auth-signup-progress-dot"></span>
                            <span class="auth-signup-progress-dot"></span>
                        </div>
                        <span class="auth-signup-eyebrow">{{ trans('login.extensible_signup_eyebrow') }}</span>
                        <h1>{{ trans('login.extensible_signup_title') }}</h1>
                        <p>{{ trans('login.extensible_signup_description') }}</p>
                    </div>

                    <div class="auth-signup-step-body" data-testid="extensible-signup-preview">
                        <div class="message error-message" v-if="signupError" role="alert">
                            <p>{{ signupError }}</p>
                        </div>

                        <div class="field">
                            <label for="name">{{ trans('login.extensible_signup_business_name') }}</label>
                            <input type="text" id="name" name="name" autocomplete="organization" v-model="name" placeholder="Flow Studio" required>
                        </div>

                        <div class="field">
                            <label for="username">{{ trans('login.extensible_signup_admin_email') }}</label>
                            <input type="email" id="username" name="email" autocomplete="email" placeholder="owner@flowstudio.dk" v-model="email" required>
                            <p class="field-help">{{ trans('login.extensible_signup_admin_email_help') }}</p>
                        </div>

                        <div class="field-row">
                            <div class="field">
                                <label for="country">{{ trans('login.country') }}</label>
                                <select name="country" id="country" v-model="country" required :style="{color: country == '' ? '#797979' : 'inherit'}">
                                    <option value="">{{ trans('login.country_placeholder') }}</option>
                                    <option v-for="(countryName, countryKey) in countries" :value="countryKey">{{ countryName }}</option>
                                </select>
                            </div>

                            <div class="field">
                                <label for="timezone">{{ trans('login.extensible_signup_timezone') }}</label>
                                <input type="text" id="timezone" name="timezone" v-model="timezone" autocomplete="off">
                                <p class="field-help">{{ trans('login.extensible_signup_timezone_help') }}</p>
                            </div>
                        </div>

                        <div class="support-box">
                            <div class="choice-title">{{ trans('login.extensible_signup_used_next_title') }}</div>
                            <p>{{ trans('login.extensible_signup_used_next_copy') }}</p>
                        </div>
                    </div>

                    <input v-if="discount" type="hidden" name="discount" v-model="discount" />
                </template>

                <template v-else-if="practizeShell">
                    <h1 class="form-title">{{ trans('login.sign_up_short') }}</h1>

                    <div class="field">
                        <label for="name">{{ trans('first_login.name') }}</label>
                        <input type="text" id="name" name="name" autocomplete="name" v-model="name" required>
                    </div>

                    <div class="field">
                        <label for="username">{{ trans('login.form_label_email') }}</label>
                        <input type="email" id="username" name="email" autocomplete="email" placeholder="name@example.com" v-model="email" required>
                    </div>

                    <div class="field">
                        <label for="country">{{ trans('login.country') }}</label>
                        <select name="country" id="country" v-model="country" required :style="{color: country == '' ? '#797979' : 'inherit'}">
                            <option value="">{{ trans('login.country_placeholder') }}</option>
                            <option v-for="(countryName, countryKey) in countries" :value="countryKey">{{ countryName }}</option>
                        </select>
                    </div>

                    <div class="field">
                        <label for="discount">{{ trans('discount_codes.discount_code') }}</label>
                        <input type="text" id="discount" name="discount" v-model="discount" />
                    </div>
                </template>

                <div class="input-container" v-else>
                    <input type="text" id="name" name="name" :placeholder="trans('first_login.name')" v-model="name" required>
                    <input type="email" id="username" name="email" :placeholder="trans('login.form_label_email')" v-model="email" required>
                    <div class="select-container">
                        <select name="country" id="country" v-model="country" required :style="{color: country == '' ? '#797979' : 'inherit'}">
                            <option value="">Select where you live</option>
                            <option v-for="(countryName, countryKey) in countries" :value="countryKey">{{ countryName }}</option>
                        </select>
                    </div>
                    <input type="text" id="discount" name="discount" v-model="discount" placeholder="discount code" />
                </div>

                <input v-if="practizeShell || practizeShellQuery" type="hidden" name="practize_shell" value="1" />

                <div v-if="extensibleOnboarding" class="auth-signup-step-actions">
                    <a class="secondary-link" href="/">{{ trans('login.have_account') }} {{ trans('login.log_in') }}</a>
                    <button id="submitLogin" class="primary-btn" :disabled="submitLoading">
                        <span v-if="!submitLoading">{{ trans('login.extensible_signup_continue') }}</span>
                        <span v-else>{{ trans('login.extensible_signup_loading') }}</span>
                    </button>
                </div>

                <button v-else id="submitLogin" :class="{ 'primary-btn': practizeShell }" :disabled="submitLoading">

                    <span v-if="!submitLoading">{{ trans('login.sign_up_short') }}</span>
 
                    <svg v-else version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                    <path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                        <animateTransform attributeType="xml"
                                          attributeName="transform"
                                          type="rotate"
                                          from="0 25 25"
                                          to="360 25 25"
                                          dur="0.6s"
                                          repeatCount="indefinite"/>
                    </path>
                    </svg>

                </button>

            </form>
        </div>
        <p v-if="!extensibleOnboarding" class="create-cta">
            <a href="/">
                {{ trans('login.have_account') }}
                <u>{{ trans('login.log_in') }}</u>
            </a>
        </p>
    </div>
</template>
